import NewCardOnTheWayScreen from 'features/cardManagement/screens/lostStolenReplaceCard/NewCardOnTheWayScreen/NewCardOnTheWayScreen';
import React from 'react';

export default function NewCardOnTheWayPage() {
  return <NewCardOnTheWayScreen />;
}
